import { Box, Text } from '@chakra-ui/react';
import {
  Divider,
  EmbedVideoWithOverlay,
  WrappedImage,
} from '@time-line/components/common';
import type { SanityImage } from '@time-line/components/types';
import { BlogDetails } from 'components/blog/BlogDetails';
import type { BlogCard } from 'types/cms/blog/BlogCard';

import { BlogShareIcons } from '../BlogShareIcons';

type HeroProps = Pick<
  BlogCard,
  'categories' | 'publishedAt' | 'updatedAt' | 'videoUrl' | 'title' | 'summary'
> & {
  image?: SanityImage;
};

export function Hero({
  categories,
  image,
  publishedAt,
  updatedAt,
  summary,
  title,
  videoUrl,
}: HeroProps) {
  return (
    <>
      <Divider mb="2xs" />
      <BlogDetails
        mb={{ base: '2xs', lg: 'sm' }}
        categories={categories}
        publishedAt={publishedAt}
        updatedAt={updatedAt}
        isCategoryClickable
      />
      <Text size="h2" as="h1">
        {title}
      </Text>
      {summary && (
        <Text mt={{ base: '2xs', lg: 'sm' }} color="blackAlpha.700">
          {summary}
        </Text>
      )}
      <Box mt="m" mb="lg">
        <BlogShareIcons title={title} />
      </Box>
      <Box position="relative" className="hero">
        {videoUrl && (
          <EmbedVideoWithOverlay videoUrl={videoUrl} overlayImage={image} />
        )}
        {image && !videoUrl && (
          <WrappedImage
            image={image}
            ratio={3 / 2}
            sizes="(min-width: 960px) 40vw, (min-width: 1920px) 1800px, 90vw"
          />
        )}
      </Box>
    </>
  );
}
